/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_Subscription_DetailsInputs */

const en_settings_billing_subscription_details = /** @type {(inputs: Settings_Billing_Subscription_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription Details`)
};

const zh_settings_billing_subscription_details = /** @type {(inputs: Settings_Billing_Subscription_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`订阅详情`)
};

/**
* | output |
* | --- |
* | "Subscription Details" |
*
* @param {Settings_Billing_Subscription_DetailsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_billing_subscription_details = /** @type {((inputs?: Settings_Billing_Subscription_DetailsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_Subscription_DetailsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_billing_subscription_details(inputs)
	return zh_settings_billing_subscription_details(inputs)
});
export { settings_billing_subscription_details as "settings.billing.subscription_details" }